import React, { useState } from 'react';

const ReleaseNotes = ({ 
  notes, 
  maxLength = 200,
  showExpandButton = true 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!notes || notes.trim() === '') {
    return (
      <div style={styles.emptyState}>
        <span style={styles.emptyIcon}>📝</span>
        <span style={styles.emptyText}>No release notes available</span>
      </div>
    );
  }

  const shouldTruncate = notes.length > maxLength && showExpandButton;
  const displayNotes = shouldTruncate && !isExpanded 
    ? notes.substring(0, maxLength) + '...' 
    : notes;

  // Preserve line breaks and basic formatting
  const formattedNotes = displayNotes.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < displayNotes.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div style={styles.container}>
      <div style={styles.notesContent}>
        {formattedNotes}
      </div>
      
      {shouldTruncate && (
        <button 
          onClick={toggleExpand}
          style={styles.expandButton}
          onMouseEnter={(e) => {
            e.target.style.color = '#2980b9';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#3498db';
            e.target.style.textDecoration = 'none';
          }}
        >
          {isExpanded ? '▲ Show less' : '▼ Read more'}
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    width: '100%'
  },
  notesContent: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#555',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    marginBottom: '8px'
  },
  expandButton: {
    background: 'none',
    border: 'none',
    color: '#3498db',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    padding: '4px 0',
    transition: 'all 0.2s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  },
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    color: '#999'
  },
  emptyIcon: {
    fontSize: '18px'
  },
  emptyText: {
    fontSize: '14px',
    fontStyle: 'italic'
  }
};

export default ReleaseNotes;
